import plusFill from '@iconify/icons-eva/close-circle-outline';
import { Icon } from '@iconify/react';
// material
import { Button, Container, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';

//
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import { UserForm } from '../components/user';
import { useTranslation } from '../common/LocalizationProvider';
// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '50vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function AddUser() {
  const t = useTranslation();
  const navigate = useNavigate();

  return (
    <Page title={t('UN_Title')}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0}>
          <Typography variant="h4" gutterBottom>
            {t('usersNew')}
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/user', { replace: true })}
            startIcon={<Icon icon={plusFill} />}
            color="secondary"
          >
            {t('btn_Cancel')}
          </Button>
        </Stack>
        <Scrollbar>
          <ContentStyle>
            <UserForm />
          </ContentStyle>
        </Scrollbar>
      </Container>
    </Page>
  );
}
